import styles from './car-maintenance-step-wrapper.module.css'
import {
  ContentSection,
  Text,
  Primary,
  Secondary,
} from '@cinch-labs/design-system'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'

export interface CarMaintenanceStepWrapperProps {
  children: React.ReactNode
  title: string
  description?: string
  descriptionElement?: React.ReactElement
  onContinue?: () => void
  showContinueButton?: boolean
  buttonText?: string
  buttonStyle?: 'primary' | 'secondary'
}

export const CarMaintenanceStepWrapper: React.FC<
  CarMaintenanceStepWrapperProps
> = ({
  children,
  title,
  description,
  descriptionElement,
  onContinue,
  showContinueButton = true,
  buttonText = 'Continue',
  buttonStyle = 'primary',
}: CarMaintenanceStepWrapperProps) => {
  const { trackEvent } = useAnalytics()
  const handleButtonClick = () => {
    if (buttonText === 'Continue without an MOT') {
      const continueWithoutEvent = {
        eventName: `Select service event`,
        type: TrackingEventTypes.ADOBE,
        data: {
          event: {
            name: EventNames.click,
            category: 'cinch_servicing',
            action: 'continue_without_mot',
            label: 'make_a_booking',
          },
        },
      }

      trackEvent(continueWithoutEvent)
    }

    onContinue?.()
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <div className={styles.container}>
      <ContentSection title={title} classNames={{ title: styles.title }}>
        {description && <Text>{description}</Text>}
        {descriptionElement && descriptionElement}
      </ContentSection>
      <div>{children}</div>
      {showContinueButton && (
        <div className={styles.buttonContainer}>
          {buttonStyle === 'primary' ? (
            <Primary
              isFullWidth
              size="large"
              onClick={handleButtonClick}
              classNames={{ button: styles.button }}
            >
              {buttonText}
            </Primary>
          ) : (
            <Secondary isFullWidth size="large" onClick={handleButtonClick}>
              {buttonText}
            </Secondary>
          )}
        </div>
      )}
    </div>
  )
}
